const defaults = {
  timeout: 5000,
}

const urls = {
  v4: 'https://ipv4.icanhazip.com/',
  v6: 'https://ipv6.icanhazip.com/',
}

const isIp = new RegExp(
  '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}'
)

function queryHttps(version, opts) {
  return new Promise((resolve, reject) => {
    const doReject = () => reject(new Error("Couldn't find your IP"))
    const xhr = new XMLHttpRequest()

    xhr.onerror = doReject
    xhr.ontimeout = doReject
    xhr.onload = () => {
      const ip = xhr.responseText.trim()

      if (!ip || !isIp.test(ip)) {
        doReject()
      }

      resolve(ip)
    }

    xhr.open('GET', urls[version])
    xhr.timeout = opts.timeout
    xhr.send()
  })
}

module.exports = opts => {
  opts = Object.assign({}, defaults, opts)
  return queryHttps('v4', opts)
    .then(() => true)
    .catch(() => false)
}



// WEBPACK FOOTER //
// ./src/utils/isOnline.js